import { useState, useEffect } from 'react'
import { getConteudoChave, putConteudoChave } from '@/api/adminApi'
import { ADMIN_KEYS, CONTEUDO_API_KEYS } from '@/utils/adminStorage'
import { AdminPage, AdminPanel } from '@/components/Admin'
import { useSaveFeedback } from '@/hooks/useSaveFeedback'
import styles from './Admin.module.css'

export function AdminVipPage() {
  const [lines, setLines] = useState<string[]>([''])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const apiChave = CONTEUDO_API_KEYS[ADMIN_KEYS.vip]
  const { notifySaved, notifyError } = useSaveFeedback()

  useEffect(() => {
    let cancelled = false
    setError(null)
    getConteudoChave(apiChave)
      .then((v) => {
        if (cancelled) return
        const text = (v ?? '').trim()
        setLines(text ? text.split(/\n/).map((s) => s.trim()) : [''])
      })
      .catch((e) => {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Erro ao carregar')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [apiChave])

  const handleSalvar = async (e: React.FormEvent) => {
    e.preventDefault()
    setSaving(true)
    setError(null)
    const value = lines.map((s) => s.trim()).filter(Boolean).join('\n') || null
    try {
      await putConteudoChave(apiChave, value)
      notifySaved('Vantagens VIP guardadas.')
    } catch (e) {
      notifyError(e, 'Erro ao salvar')
      setError(e instanceof Error ? e.message : 'Erro ao salvar')
    } finally {
      setSaving(false)
    }
  }

  const updateLine = (index: number, text: string) => {
    setLines((prev) => {
      const next = [...prev]
      next[index] = text
      return next
    })
  }

  const removeLine = (index: number) => {
    if (lines.length <= 1) return
    setLines((prev) => prev.filter((_, i) => i !== index))
  }

  const addLine = () => {
    setLines((prev) => [...prev, ''])
  }

  return (
    <AdminPage
      title="VIP"
      subtitle="Uma vantagem por linha. A ordem aqui é a ordem de exibição no app."
      loading={loading}
      error={error}
    >
      <form onSubmit={handleSalvar}>
        <AdminPanel
          title={
            <>
              Vantagens do programa VIP
              {lines.length > 0 && (
                <span className={styles.listCountBadge}>{lines.length}</span>
              )}
            </>
          }
          footer={
            <button type="submit" className={styles.btnSalvar} disabled={saving}>
              {saving ? 'A guardar…' : 'Guardar vantagens'}
            </button>
          }
        >
          <div className={styles.listEditorScroll}>
            {lines.map((line, i) => (
              <div key={i} className={styles.vipListItem}>
                <span className={styles.rowIndex}>{i + 1}</span>
                <input
                  type="text"
                  value={line}
                  onChange={(e) => updateLine(i, e.target.value)}
                  placeholder={`Vantagem ${i + 1}`}
                />
                <button
                  type="button"
                  className={styles.vipBtnRemove}
                  onClick={() => removeLine(i)}
                  disabled={lines.length <= 1}
                  aria-label="Remover vantagem"
                >
                  Remover
                </button>
              </div>
            ))}
          </div>
          <div className={styles.vipListAdd}>
            <button type="button" className={styles.vipBtnAdd} onClick={addLine}>
              + Adicionar vantagem
            </button>
          </div>
        </AdminPanel>
      </form>
    </AdminPage>
  )
}
